export default __webpack_public_path__ + "static/media/prev.821ce996.svg";